import React, { FunctionComponent } from 'react'
import initials from 'utils/initials'

interface IManagerTagProps {
  type: 'creator' | 'owner'
  fullName: string
  variant?: 'booking'
  align?: 'right' | 'left'
  onlyName?: boolean
  customTooltip?: string
}

// The circle with initials on the right-hand side.
export const ManagerTag: FunctionComponent<IManagerTagProps> = ({
  align = 'left',
  customTooltip,
  fullName,
  onlyName,
  type,
  variant,
}) => {
  const className = 'tag tag-medium tag-round'
  const alignmentClass = `${align === 'right' ? 'align-right' : 'mr2'}`
  const info = {
    owner: {
      className: 'text-inverse bg-accent',
      tooltip: customTooltip || `${fullName}`,
    },
    secondary: {
      className: 'text-secondary bg-disabled',
      tooltip: customTooltip || `${fullName}`,
    },
    creator: {
      className: 'text-secondary bg-secondary',
      tooltip: customTooltip || `${fullName}`,
    },
  }

  return variant === 'booking' ? (
    <span
      data-tooltip={`${type} Rep: ${fullName}`}
      className={`${className} ${info.secondary.className} ${alignmentClass}`}>
      {initials(fullName, onlyName)}
    </span>
  ) : (
    <span
      data-tooltip={info[type].tooltip}
      className={`${className} ${info[type].className} ${alignmentClass} ${
        onlyName ? 'tag-single-letter' : ''
      }`}>
      {initials(fullName, onlyName)}
    </span>
  )
}

export default ManagerTag
